
import orientation from "../data/orientation.json";

let initialState = {
  isOpen: localStorage.getItem('orientationOptOut') !== "true",
  step: 0,
  data: orientation
};


export default function(state = initialState, action){

  switch(action.type){

    case "@@router/LOCATION_CHANGE":
      return {
        ...state
      };

    case "orientation/OPENED":
      return {
        ...state,
        isOpen: true,
        step: 0
      };

    case "orientation/CLOSED":
      return {
        ...state,
        isOpen: false,
        step: 0
      };

    case "orientation/NEXT":
      return {
        ...state,
        step: state.step + 1
      };

    case "orientation/BACK":
      return {
        ...state,
        step: state.step - 1
      };

    default: return state;
  }

}



// WEBPACK FOOTER //
// ./src/reducers/orientation.js